export default "__VITE_ASSET__Cobyy5GS__"